enum ProjectState {
    Ready = 'ready',
    Processing = 'processing',
    Locked = 'locked'
}

export default ProjectState;
